import {
  TAB_LIST_REQUEST,
  TAB_LIST_SUCCESS,
  TAB_LIST_FAILURE,
} from "../../action/types";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const TabMasterReducer = (state = initialState, action) => {
  switch (action.type) {
    case TAB_LIST_REQUEST:
      return { ...state, loading: true, error: null };
    case TAB_LIST_SUCCESS:
      return { ...state, data: action.payload, loading: false, error: null };
    case TAB_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default TabMasterReducer;
